import React from 'react';
import { 
  Footer, 
  FooterTop, 
  FooterBottom, 
  FooterBrand, 
  FooterSection, 
  FooterLink, 
  SocialIcon, 
  Copyright 
} from './';
import logo from '../assets/logo_dark.png';
import soc2Image from '../assets/soc 2.png';
import isoImage from '../assets/iso.png';

interface UnifiedFooterProps {
  itemVariants?: any;
  className?: string;
}

export const UnifiedFooter: React.FC<UnifiedFooterProps> = ({
  itemVariants,
  className = '',
}) => {
  return (
    <Footer itemVariants={itemVariants} className={className}>
      {/*<FooterTop className="!flex !justify-between !items-start !grid-cols-none">
        {/*<FooterBrand
          logo={logo}
          alt="Syntra"
          description="Securing the future of voice AI with advanced threat detection and protection."
        >
          <SocialIcon href="https://www.linkedin.com/company/syntrainc">
            <svg className="w-4 h-4 text-dark-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM8.5 18.5H5.5V9.5H8.5V18.5ZM7 8.5C6.2 8.5 5.5 7.8 5.5 7C5.5 6.2 6.2 5.5 7 5.5C7.8 5.5 8.5 6.2 8.5 7C8.5 7.8 7.8 8.5 7 8.5ZM18.5 18.5H15.5V13.9C15.5 12.7 14.5 11.9 13.5 11.9C12.5 11.9 11.5 12.7 11.5 13.9V18.5H8.5V9.5H11.5V10.5C12.1 9.9 13.1 9.5 14 9.5C16.4 9.5 18.5 11.6 18.5 14V18.5Z" fill="currentColor" />
            </svg>
          </SocialIcon>
        </FooterBrand>*/}

        {/*<FooterSection title="Company" className="text-right">
          <FooterLink href="/">About</FooterLink>
          <FooterLink href="/">Trust Center</FooterLink>
          <FooterLink href="/careers">Careers</FooterLink>
          <FooterLink href="mailto:contact@syntra.io">Contact</FooterLink>
        </FooterSection>
      </FooterTop>*/}

      <FooterBottom>
        <div className="flex items-center space-x-4">
          <img 
            src={soc2Image} 
            alt="SOC 2 Compliant" 
            className="h-12 w-auto opacity-80 hover:opacity-100 transition-opacity"
          />
          <img 
            src={isoImage} 
            alt="ISO 27001 Certified" 
            className="h-12 w-auto opacity-80 hover:opacity-100 transition-opacity"
          />
        </div>
        <Copyright companyName="Syntra" />
      </FooterBottom>
    </Footer>
  );
}; 